// 登录页图片资源：仅保留当前实际渲染的 banner / 注册弹层 / 页脚背景
import banner_title_telephone from '@/assets/images/login/banner_title_telephone.gif';
import getImg, { getJdiosWebpImageUrl } from '@/util/getImg';

const banner_background = 'https://jdios.jdindustry.com/mixedgeneral/ME1783048531760_1783048609266.png';
const banner_register =
  'https://img13.360buyimg.com/imagetools/jfs/t1/202956/37/24932/39179/62c2a59eEab823185/f823d5941f4501d4.png';

// 登录 Banner 用全图 WebP + CSS cover 铺满宽屏；勿 shb 固定 1920×540，否则 ultrawide 下两侧易露底
export const LOGIN_BANNER_LCP_IMAGE_URL = getJdiosWebpImageUrl(banner_background);

const PIC_ENMU = {
  banner: {
    banner_title_telephone: banner_title_telephone,
    banner_background: {
      backgroundSize: 'cover',
      backgroundPosition: '50%',
      backgroundImage: `url(${LOGIN_BANNER_LCP_IMAGE_URL})`,
    },
    banner_register: {
      backgroundSize: 'cover',
      backgroundPosition: '50%',
      backgroundImage: `url(${getImg(banner_register, 1020, 200)})`,
    },
  },
  bottomBackground: {
    width: '100%',
    height: '100%',
    background: '#3D4352',
  },
};

export default PIC_ENMU;
